import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * B-02A (CA-03) — Visual alert when `gastos_embarque.alerta_ocr_base = true`.
 * The base amount was derived automatically (monto / 1.19) because the OCR
 * failed to extract it. Requires human verification before liquidation.
 */
export function OcrBaseAlertIcon({ active }: { active: boolean | null | undefined }) {
  if (!active) return null;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center cursor-help shrink-0"
            aria-label="Base derivada automáticamente — requiere revisión"
          >
            <AlertTriangle size={14} className="text-amber-500" strokeWidth={2.25} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs max-w-[280px]">
          Base gravable derivada automáticamente (OCR). Monto base = monto ÷ 1.19. Verifica con la factura original antes de liquidar.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
